import Carousel from "react-bootstrap/Carousel";
import { useNewHomeAPI } from "../../hooks/useAllCategoryData";
import ShimmerSingleBox from "../ShimmerSingleBox";
//import "./HomeBanner.css";

function HomeBanner() {
  const { isLoading, error, data } = useNewHomeAPI();

  if (error) return <div>{error.message}</div>;

  return (
    <>
      {isLoading && (
        <div className="products home-banner-shimmer">
          {Array.from({ length: 1 }, (_, index) => (
            <ShimmerSingleBox
              key={index}
              CustomStyle={{ height: "100vh" }}
            />
          ))}
        </div>
      )}

      {data?.bannerNew && (
        <Carousel
          className="home-banner"
          fade
          interval={90000}
          pause={false}
          touch
          controls={true}
          indicators={false}
        >
          {data.bannerNew.map((e, i) => (
            <Carousel.Item key={i}>
              {/* Banner Image */}
              {/* <img
                className="home-banner-image"
                src={`${process.env.REACT_APP_IMAGE_URL}/home/banner/${e.url}`}
                alt={e.heading || "Chaashni Collection"}
              /> */}

              <picture className="home-banner-image">
                <source media="(min-width:768px)" srcset={`${process.env.REACT_APP_IMAGE_URL}home/banner/${e.url}`} />  
                <img src={`${process.env.REACT_APP_IMAGE_URL}home/banner/m-${e.url}`} alt={e.heading || "Chaashni Collection"} />
              </picture>

              {/* Dark/Light overlay */}
              <div className="home-banner-overlay"></div>

              {/* Main Content */}
              <div className={`home-banner-content ${e.box || ''}`}>
                <h2 dangerouslySetInnerHTML={{ __html: e.heading }} />
                <p>{e.content}</p>
              </div>

              {/* Bottom Navigation */}
              
              <div className={`bottom-box-wrap ${e.bottomColor}`} dangerouslySetInnerHTML={{ __html: e.bottomTab }} />
             
            </Carousel.Item>
          ))}
        </Carousel>
      )}
    </>
  );
}

export default HomeBanner;